<kiwi-decision-content class="cell-block-y ingredientsPurchasing" (saved)="save()">
    <div class="cell auto grid-x" *ngIf="decision">
        <div class="cell xsmall-24 xlarge-16">
            <fieldset>
                <legend [i18nKey]="'decisions.menu.ingredients.purchasing.tab'"></legend>
                <div class="grid-x grid-margin-x">
                    <table class="cell xsmall-24 xxlarge-12 _tableColor">
                        <tbody>
                        <tr class="_titlePartTable">
                            <td [i18nKey]="'menu.first.courses'"></td>
                            <td class="_number"[i18nKey]="'common.quality'"></td>
                            <td class="_number"[i18nKey]="'decisions.menu.purchasing.prices.excluding.taxes'"></td>
                        </tr>

                        <tr *ngFor="let firstCourseName of decision.firstCoursesPurchases | keys">
                            <td>{{'menu.' + firstCourseName | translate}}</td>
                            <td>
                                <kiwi-number-input
                                    [name]="decision.firstCoursesPurchases[firstCourseName] + '-quality'"
                                    [(ngModel)]="decision.firstCoursesPurchases[firstCourseName].quality"
                                    [min]="decision.minDishQuality"
                                    [max]="decision.maxDishQuality"
                                    (change)="updateFirstCoursePurchasingPrice(firstCourseName)"
                                    [disabled]="decisionsReadonly">
                                </kiwi-number-input>
                            </td>
                            <td class="_number">
                                {{decision.firstCoursesPurchases[firstCourseName].purchasingPriceExcludingTax | number:'1.2'}}
                            </td>
                        </tr>
                        </tbody>
                    </table>
                    <table class="cell xsmall-24 xxlarge-12 _tableColor">
                        <tbody>
                        <tr class="_titlePartTable">
                            <td [i18nKey]="'menu.meat.dishes'"></td>
                            <td class="_number"[i18nKey]="'common.quality'"></td>
                            <td class="_number"[i18nKey]="'decisions.menu.purchasing.prices.excluding.taxes'"></td>
                        </tr>

                        <tr *ngFor="let meatDishName of decision.meatDishesPurchases | keys">
                            <td>{{'menu.' + meatDishName | translate}}</td>
                            <td>
                                <kiwi-number-input [(ngModel)]="decision.meatDishesPurchases[meatDishName].quality"
                                       [name]="decision.firstCoursesPurchases[meatDishName] + '-quality'"
                                       [min]="decision.minDishQuality"
                                       [max]="decision.maxDishQuality"
                                       (change)="updateMeatDishPurchasingPrice(meatDishName)"
                                       [disabled]="decisionsReadonly">
                                </kiwi-number-input>
                            </td>
                            <td class="_number">
                                {{decision.meatDishesPurchases[meatDishName].purchasingPriceExcludingTax | number:'1.2'}}
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <div class="grid-x grid-margin-x">
                    <table class="cell xsmall-24 xxlarge-12 _tableColor">
                        <tbody>
                        <tr class="_titlePartTable">
                            <td [i18nKey]="'menu.fish.dishes'"></td>
                            <td class="_number"[i18nKey]="'common.quality'"></td>
                            <td class="_number"[i18nKey]="'decisions.menu.purchasing.prices.excluding.taxes'"></td>
                        </tr>

                        <tr *ngFor="let fishDishName of decision.fishDishesPurchases | keys">
                            <td>{{'menu.' + fishDishName | translate}}</td>
                            <td>
                                <kiwi-number-input [(ngModel)]="decision.fishDishesPurchases[fishDishName].quality"
                                       [name]="decision.firstCoursesPurchases[fishDishName] + '-quality'"
                                       [min]="decision.minDishQuality"
                                       [max]="decision.maxDishQuality"
                                       (ngModelChange)="updateFishDishPurchasingPrice(fishDishName)"
                                       [disabled]="decisionsReadonly">
                                </kiwi-number-input>
                            </td>
                            <td class="_number">
                                {{decision.fishDishesPurchases[fishDishName].purchasingPriceExcludingTax | number:'1.2'}}
                            </td>
                        </tr>
                        </tbody>
                    </table>
                    <table class="cell xsmall-24 xxlarge-12 _tableColor">
                        <tbody>
                        <tr class="_titlePartTable">
                            <td [i18nKey]="'menu.desserts'"></td>
                            <td class="_number"[i18nKey]="'common.quality'"></td>
                            <td class="_number"[i18nKey]="'decisions.menu.purchasing.prices.excluding.taxes'"></td>
                        </tr>

                        <tr *ngFor="let dessertName of decision.dessertsPurchases | keys">
                            <td>{{'menu.' + dessertName | translate}}</td>
                            <td>
                                <kiwi-number-input [(ngModel)]="decision.dessertsPurchases[dessertName].quality"
                                       [name]="decision.firstCoursesPurchases[dessertName] + '-quality'"
                                       [min]="decision.minDishQuality"
                                       [max]="decision.maxDishQuality"
                                       (ngModelChange)="updateDessertPurchasingPrice(dessertName)"
                                       [disabled]="decisionsReadonly">
                                </kiwi-number-input>
                            </td>
                            <td class="_number">
                                {{decision.dessertsPurchases[dessertName].purchasingPriceExcludingTax | number:'1.2'}}
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </fieldset>
        </div>

        <kiwi-score-image class="cell xsmall-24 xlarge-8"
                          [imgQualityClass]="imgClass"
                          [scores]="scores"
                          [imgType]="'_ingredientsPurchasing'">
        </kiwi-score-image>
    </div>
</kiwi-decision-content>
